import React from 'react'
import ReactDOM from 'react-dom'
import { DOMRender, getLayout } from './lib/ep';
import qreducer from './reducers/questions';
import { intlReducer } from 'react-intl-redux'
import { combineReducers } from 'redux';
import { configureStore } from './store/configureStore';
import { IntlProvider as IP, addLocaleData } from 'react-intl';
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';

import BackgroundImage from './components/front/BackgroundImage';
import BracketMosaic from './components/front/BracketMosaic';
import CookiesAdvise from './components/front/layers/CookiesAdvise'
import FooterFlex from './components/front/FooterFlex';
import InstagramMediaPicker from './components/front/InstagramMediaPicker'
import Layout from './components/front/Layout';
import MainMenuFlex from './components/front/MainMenuFlex';
import MyNetworks from './components/front/MyNetworks';
import MyParticipation from './components/front/MyParticipation';
import MyParticipationMenuHeader from './components/front/MyParticipationMenuHeader'
import MyParticipationMultistage from './components/front/MyParticipationMultistage';
import PunchCardStandalone from './components/front/PunchCardStandalone';
import NotAllowed from './components/front/NotAllowed';
import ProtectedPromo from './components/front/ProtectedPromo';
import SocialLogin from './components/front/SocialLogin'
import StageMosaic from './components/front/StageMosaic';
import SweepsCertificate from './components/front/SweepsCertificate';
import PrizeCertificate from './components/front/PrizeCertificate';
import TestInvite from './components/front/TestInvite';
import UserPhotoEditor from './components/front/UserPhotoEditor';
import UserPhotoEditorOld from './components/front/UserPhotoEditor_old';
import ViewCurrentUsers from './components/front/ViewCurrentUsers';

import AgeRestriction from './components/front/layers/AgeRestriction';
import LegalText from './components/front/layers/LegalText'

import ButtonQuizStats from './components/front/quiz/ButtonQuizStats';
import QuizGameResult from './components/front/quiz/QuizGameResult';

import CssVars from './components/utils/CssVars';

import BracketsCanvas from './components/games/BracketsCanvas';
import ScratchCanvas from './components/games/ScratchCanvas';
import PunchCardCanvas from './components/games/PunchCardCanvas';
import CatchItCanvas from './components/games/CatchItCanvas';

import PrizesPage from './components/prizes/PrizesPage';
import RedeemPrize from './components/prizes/RedeemPrize';
import RouletteLayer from './components/prizes/RouletteLayer';

import CustomTerms from './components/users/CustomTerms';
import EntriesMultiGallery from './components/users/EntriesMultiGallery';
import EntriesRanking from './components/users/EntriesRanking';
import PromotionBracketsMosaic from './components/users/PromotionBracketsMosaic';
import PromotionLanding from './components/users/PromotionLanding';

import InstagramClaimButton from './components/sweeps/InstagramClaimButton';

import TeamStage from './containers/stages/TeamStage';

import Autologin from './containers/Autologin';
import ClaimPrize from './containers/ClaimPrize';
import ClaimPromoLive from './containers/ClaimPromoLive';
import ClaimPrizeAttachment from './containers/ClaimPrizeAttachment';
import PointsOfSalePortal from './containers/PointsOfSalePortal';
import CustomHTMLDomain from './containers/CustomHTMLDomain';
import LoginRegister from './containers/LoginRegister';
import Participate from './containers/Participate';
import QuizClient from './containers/QuizClient';
import QuizMonitor from './containers/QuizMonitor';
import ShareParticipation from './containers/ShareParticipation';
import SuccessFinalButtons from './containers/SuccessFinalButtons';
import UserPrizes from './containers/UserPrizes';
import UserRewards from './containers/UserRewards';
import WidgetHeightAdapter from './containers/WidgetHeightAdapter';

import CrosswordsCanvas from './components/games/CrosswordsCanvas';
import PeelMeContainer from './components/games/PeelMeContainer';

import TimeCounterSimple from './components/builder/TimeCounterSimple';

import Galleries from './containers/media/Galleries';

import { PromotionProvider } from './components/context/promotionContext';
import { CommonProvider } from './components/context/commonContext';

import SweepsCertificateList from './components/users/SweepsCertificateList';

import LoginReminder from './components/elements/LoginReminder';
import PrizeGallery from './components/front/loyalty/PrizeGallery';
import EarnedPointsMessage from './components/front/loyalty/EarnedPointsMessage';
import TermsButton from './components/front/buttons/TermsButton';
import PublicMessageInLayer from './components/front/layers/PublicMessageInLayer';
import UserClaim from './containers/UserClaim';
import PWAInstallBanner from './components/front/PWAInstallBanner';

import ('react-tooltip/dist/react-tooltip.css');

addLocaleData([...en, ...es]);

//Supress locales message
if(process.env.NODE_ENV !== 'production' || window.server_type !== '0') {
	const originalConsoleError = console.error
	if(console.error === originalConsoleError) {
		console.error = (...args) => {
			if(args[0].indexOf('[React Intl]') === 0) {
				return
			}
			originalConsoleError.call(console, ...args)
		}
	}
}

var intlStart = start_locales;
let storeQuestions;

//Define the exposed module that will allow to create
//the different pages or zones by calling this module's functions
const EPREACTFRONT = {
	initQuiz:(questions, pm) => {
		const start = {
			intl:intlStart,
			questions:{
				questions:questions,
				pm:pm,
			}
		}

		const reducer = combineReducers({
			questions:qreducer,
			intl:intlReducer,
		});

		storeQuestions = configureStore(start, reducer);
	},

	QuizMonitor:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<QuizMonitor {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	SocialLogin:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<SocialLogin {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	RedeemPrize: (element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<RedeemPrize {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	RouletteLayer: (element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<RouletteLayer {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	InstagramMediaPicker:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<InstagramMediaPicker {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	MainMenuFlex:(element, data) => {
		data.promo.layout_props = getLayout(data.promo);

		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<MainMenuFlex ref={(e) => { window.menu_ref = e }} {...data} />
			</IP>,
			element
		);
	},

	FooterFlex:(element, data) => {
		data.promo.layout_props = getLayout(data.promo);

		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<FooterFlex {...data} />
			</IP>,
			element
		);
	},

	MyParticipation:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<CommonProvider data={data.common}>
					<PromotionProvider promotion={data.promotion} menus={data.menus}>
						<Layout
							page='my_participation'
							langs={data.common.langs}
							{...data}
						>
							<WidgetHeightAdapter>
								<MyParticipation {...data} />
							</WidgetHeightAdapter>
						</Layout>
					</PromotionProvider>
				</CommonProvider>
			</IP>,
			element
		);
	},

	UserPrizes:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<CommonProvider data={data.common}>
					<PromotionProvider promotion={data.promotion} menus={data.menus}>
						<WidgetHeightAdapter>
							<UserPrizes {...data} />
						</WidgetHeightAdapter>
					</PromotionProvider>
				</CommonProvider>
			</IP>,
			element
		);
	},

	UserClaim:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<CommonProvider data={data.common}>
					<PromotionProvider promotion={data.promotion} menus={data.menus}>
						<Layout
							page='my_prizes'
							langs={data.common.langs}
							{...data}
						>
							<WidgetHeightAdapter>
								<UserClaim {...data} />
							</WidgetHeightAdapter>
						</Layout>
					</PromotionProvider>
				</CommonProvider>
			</IP>,
			element
		);
	},

	UserRewards:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<CommonProvider data={data.common}>
					<PromotionProvider promotion={data.promotion} menus={data.menus}>
						<Layout
							page='my_rewards'
							langs={data.common.langs}
							{...data}
						>
							<WidgetHeightAdapter>
								<UserRewards {...data} />
							</WidgetHeightAdapter>
						</Layout>
					</PromotionProvider>
				</CommonProvider>
			</IP>,
			element
		);
	},

	PunchCardStandalone:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<CommonProvider data={data.common}>
					<PromotionProvider promotion={data.promotion} menus={data.menus}>
						<Layout
							page='loyalty_cards'
							langs={data.common.langs}
							{...data}
						>
							<WidgetHeightAdapter>
								<PunchCardStandalone {...data} />
							</WidgetHeightAdapter>
						</Layout>
					</PromotionProvider>
				</CommonProvider>
			</IP>,
			element
		);
	},

	MyParticipationMultistage:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<CommonProvider data={data.common}>
					<PromotionProvider promotion={data.promotion} menus={data.menus}>
						<Layout
							page='my_participation'
							langs={data.common.langs}
							{...data}
						>
							<WidgetHeightAdapter>
								<MyParticipationMultistage {...data} />
							</WidgetHeightAdapter>
						</Layout>
					</PromotionProvider>
				</CommonProvider>
			</IP>,
			element
		);
	},

	MyParticipationMenuHeader:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<MyParticipationMenuHeader {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	QuizClient:(element, data, doreturn) => {
		let store = storeQuestions;
		data = {...data,store}

		if(doreturn != undefined) {
			return (
				<IP locale={start_locales.locale} messages={start_locales.messages}>
					<WidgetHeightAdapter>
						<QuizClient {...data} />
					</WidgetHeightAdapter>
				</IP>
			);
		}

		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<QuizClient {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	PrizesPage:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<CommonProvider data={data.common}>
					<PromotionProvider promotion={data.promotion} menus={data.menus}>
						<Layout
							page='winners'
							langs={data.common.langs}
							{...data}
						>
							<WidgetHeightAdapter>
								<PrizesPage {...data} />
							</WidgetHeightAdapter>
						</Layout>
					</PromotionProvider>
				</CommonProvider>
			</IP>,
			element
		);
	},

	SuccessFinalButtons:(element, data) => {
		data.promotion.Promotion.layout_props = getLayout(data.promotion.Promotion);

		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<SuccessFinalButtons {...data} />
			</IP>,
			element
		);
	},

	CustomHTMLDomain:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<CustomHTMLDomain {...data} />
			</IP>,
			element
		);
	},

	QuizGameResult:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<QuizGameResult {...data} />
			</IP>,
			element
		);
	},

	BracketsCanvas:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<BracketsCanvas {...data} />
			</IP>,
			element
		);
	},

	CssVars:(element, data) => {
		DOMRender(
			<CssVars ref={(e) => { window.css_var = e }} {...data} />,
			element
		);
	},

	SweepsCertificateList:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<SweepsCertificateList {...data} />
			</IP>,
			element
		);
	},

	LoginReminder:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<LoginReminder {...data} />
			</IP>,
			element
		);
	},

	ScratchCanvas:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<ScratchCanvas {...data} />
			</IP>,
			element
		);
	},

	PunchCardCanvas:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<PunchCardCanvas {...data} />
			</IP>,
			element
		);
	},

	CatchItCanvas:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<CatchItCanvas {...data} />
			</IP>,
			element
		);
	},

	BracketMosaic:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<BracketMosaic {...data} />
			</IP>,
			element
		);
	},

	ClaimPrize:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<ClaimPrize {...data} />
			</IP>,
			element
		);
	},

	StageMosaic:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<StageMosaic {...data} />
			</IP>,
			element
		);
	},

	PromotionBracketsMosaic:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<PromotionBracketsMosaic {...data} />
			</IP>,
			element
		);
	},

	TestInvite:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<TestInvite {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	NotAllowed:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<NotAllowed {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	ProtectedPromo:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<ProtectedPromo {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	BackgroundImage:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<BackgroundImage {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	SweepsCertificate:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<SweepsCertificate {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	PrizeCertificate:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<PrizeCertificate {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	TimeCounterSimple:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<TimeCounterSimple {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	EntriesRanking:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<EntriesRanking {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	PointsOfSalePortal:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<PointsOfSalePortal {...data} />
			</IP>,
			element
		);
	},

	TeamStage:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<TeamStage {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	Autologin:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<Autologin {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	MyNetworks:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<MyNetworks {...data} 
					close={(button) => {
						ReactDOM.unmountComponentAtNode(document.getElementById(element));
						if(button == 'button' && data.onClose != undefined) {
							data.onClose();
						}
					}} 
				/>
			</IP>,
			element
		);
	},

	// when all frontend is react, this can be removed:
	AgeRestriction:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<AgeRestriction {...data} onAgeSelected={(age) => {
					ReactDOM.unmountComponentAtNode(document.getElementById(element));

					if(data.onAgeSelected != undefined)  data.onAgeSelected(age);
				}} />
			</IP>,
			element
		);
	},

	LoginRegister:(element, data, doreturn) => {
		data = {...data}
		if(doreturn != undefined) {
			return (
				<IP locale={start_locales.locale} messages={start_locales.messages}>
					<WidgetHeightAdapter>
						<LoginRegister {...data} />
					</WidgetHeightAdapter>
				</IP>
			);
		}

		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<LoginRegister {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	LoginRegisterFull:(element, data, doreturn) => {
		data = {...data}
		if(doreturn != undefined) {
			return (
				<IP locale={start_locales.locale} messages={start_locales.messages}>
					<WidgetHeightAdapter>
						<LoginRegister {...data} />
					</WidgetHeightAdapter>
				</IP>
			);
		}

		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<CommonProvider data={data.common}>
					<PromotionProvider promotion={data.promotion} menus={data.menus}>
						<Layout
							page='login'
							langs={data.common.langs}
							share_info={data.share_info}
						>
							<WidgetHeightAdapter>
								<LoginRegister {...data} />
							</WidgetHeightAdapter>
						</Layout>
					</PromotionProvider>
				</CommonProvider>
			</IP>,
			element
		);
	},

	Participate:(element, data, doreturn) => {
		let store = storeQuestions;
		data = {...data,store}

		data.promotion.Promotion.layout_props = getLayout(data.promotion.Promotion);

		if(doreturn != undefined) {
			return (
				<IP locale={start_locales.locale} messages={start_locales.messages}>
					<WidgetHeightAdapter>
						<Participate {...data} />
					</WidgetHeightAdapter>
				</IP>
			);
		}

		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<Participate {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	ShareParticipation:(element, data) => {
		if(data == undefined) data = {};

		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<ShareParticipation {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	Quiz:(element, pm, data) => {
		if(data == undefined) data = {};

		ReactDOM.unmountComponentAtNode(document.getElementById(element));

		let store = storeQuestions;

		data = {...data,store}

		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<Quiz pm={pm} {...data} />
			</IP>,
			element
		);
	},

	ClientQuizStats:(element, data) => {
		if(data == undefined) data = {};

		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<ButtonQuizStats {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	CustomTerms:(element, data) => {
		if(data == undefined) data = {};

		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<CustomTerms {...data} />
			</IP>,
			element
		);
	},

	PromotionLanding:(element, data) => {
		if(data == undefined) data = {};

		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<CommonProvider data={data.common}>
					<PromotionProvider promotion={data.promotion} menus={data.menus}>
						<Layout
							page='landing'
							langs={data.common.langs}
							{...data}
						>
							<WidgetHeightAdapter>
								<PromotionLanding {...data} />
							</WidgetHeightAdapter>
						</Layout>
					</PromotionProvider>
				</CommonProvider>
			</IP>,
			element
		);
	},

	EntriesMultiGallery:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<EntriesMultiGallery {...data} />
			</IP>,
			element
		);
	},

	Galleries:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<Galleries {...data} />
			</IP>,
			element
		);
	},

	CrosswordsCanvas:(element, pm, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<CrosswordsCanvas pm={pm} {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	PeelMeContainer:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<PeelMeContainer {...data} />
			</IP>,
			element
		);
	},

	UserPhotoEditor:(element, pm, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<UserPhotoEditor pm={pm} {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	UserPhotoEditorOld:(element, pm, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<WidgetHeightAdapter>
					<UserPhotoEditorOld pm={pm} {...data} />
				</WidgetHeightAdapter>
			</IP>,
			element
		);
	},

	LegalText:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<LegalText {...data} />
			</IP>,
			element
		);
	},

	PWAInstallBanner:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<PWAInstallBanner {...data} />
			</IP>,
			element
		);
	},

	CookiesAdvise:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}/* onError={(error) => console.error('IntlProvider error:', error)}*/>
				<CookiesAdvise {...data} />
			</IP>,
			element
		);
	},

	ViewCurrentUsers:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<ViewCurrentUsers {...data} />
			</IP>,
			element
		);
	},

	ClaimPromoLive:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<ClaimPromoLive {...data} />
			</IP>,
			element
		);
	},

	ClaimPrizeAttachment:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<ClaimPrizeAttachment {...data} />
			</IP>,
			element
		);
	},

	EarnedPointsMessage:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<EarnedPointsMessage {...data} />
			</IP>,
			element
		);
	},

	TermsButton:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<TermsButton {...data} />
			</IP>,
			element
		);
	},

	PrizeGallery:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<CommonProvider data={data.common}>
					<PromotionProvider promotion={data.promotion} menus={data.menus}>
						<Layout
							page='prize_gallery'
							langs={data.common.langs}
							{...data}
						>
							<WidgetHeightAdapter>
								<PrizeGallery
									{...data}
								/>
							</WidgetHeightAdapter>
						</Layout>
					</PromotionProvider>
				</CommonProvider>
			</IP>,
			element
		);
	},

	PublicMessageInLayer:(element, data) => {
		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<PublicMessageInLayer ref={(e) => { window.public_message = e }} {...data} />
			</IP>,
			element
		);
	},

	InstagramClaimButton:(element, data) => {
		if(data == undefined) data = {};

		DOMRender(
			<IP locale={start_locales.locale} messages={start_locales.messages}>
				<InstagramClaimButton {...data} />
			</IP>,
			element
		);
	},
}
EPREACTFRONT.storeQuestions = storeQuestions;

export default EPREACTFRONT;
require("expose-loader?EPREACTFRONT!EPREACTFRONT");